import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { intelligentServicesCompaniesApiConfig } from '../../IntelligentServicesConfig';
import { Worksite } from '../../types/Companies/Worksite';
import { Company } from '../../types/Companies/Company';

const dynamicBaseQuery: ReturnType<typeof fetchBaseQuery> = (
  args,
  api,
  extraOptions
) => {
  const latestBaseUrl = intelligentServicesCompaniesApiConfig.baseUrl;
  const rawBaseQuery = fetchBaseQuery({ baseUrl: latestBaseUrl });
  return rawBaseQuery(args, api, extraOptions);
};

export const companiesApi = createApi({
  reducerPath: 'companiesApi',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getCompanies: builder.query<Company[], string>({
      query: (searchInput) => `/foretag?s=${searchInput}`,
    }),
    getWorksites: builder.query<Worksite[], string>({
      query: (searchInput) => `/arbetsstallen?orgnr=${searchInput}`,
    }),
  }),
});
export const {
  useLazyGetCompaniesQuery,
  useGetCompaniesQuery,
  useLazyGetWorksitesQuery,
  useGetWorksitesQuery,
} = companiesApi;
